;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, maps, forms, Form, Field;

    function initContentContext(){

        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        function ContentContext(options){
            this.base.apply(this, arguments);
        }
        ContentContext.prototype = Object.create(Field.prototype);
        ContentContext.prototype.constructor = ContentContext;
        ContentContext.prototype.create = function(options){
            var contentId = forms.createControlGroup({name: 'content_object_id', type: 'hidden'}),
                contentType = forms.createControlGroup({name: 'content_object_type', type: 'hidden'});

            this.element = $.el.div(contentId, contentType);
            this.name = 'content_context';

            $(this.element).hide();

            return this;
        };
        ContentContext.prototype.init = function(form, next){
            if(form.submission.context){
                $(this.element).find('[name=content_object_id]').val(form.submission.context.objectId);
                $(this.element).find('[name=content_object_type]').val(form.submission.context.contentTypeId);
            }

            next();

            return this;
        };

        rnn.modules.contentContext.ContentContext = ContentContext;
    }

    rnn.modules.register('contentContext', {
        init: initContentContext
    });

})(jQuery);
